module.exports = __webpack_public_path__ + "641092372d63e98442027bd306ebd864.svg";